<template>
    <master-layout>

        <div class="breadcamb_box">
            <div>
                <h4 class="page-title m-b-0"><i class="ti-plug"></i> {{ $t('integrations') }} </h4>
                <ol class="breadcrumb">
                    <li><router-link :to="{ name: 'integrations.index' }">{{ $t('integrations') }}</router-link></li>
                    <li class="active">iCal - {{ $t('calendar') }}</li>
                </ol>
            </div>
            <pml-back-button></pml-back-button>
        </div>

        <div class="card-box icon_integration">
            <div class="bar-widget m-b-15">
                <div class="table-box">
                    <div class="table-detail w_60">
                        <div class="iconbox">
                            <i class="ti-calendar"></i>
                        </div>
                    </div>
                    <div class="table-detail">
                        <h5 class="m-t-0 m-b-5 d_inline_b">
                            <b>iCal - {{ $t('calendar') }}</b>
                        </h5>
                        <p class="m-b-5 text-muted">{{ $t('_integrations.description_ical') }}</p>
                    </div>
                </div>
            </div>
            <p>{{ $t('_integrations.ical.line_01') }}:</p>
            <ul>
                <li>{{ $t('google_calendar') }}</li>
                <li>{{ $t('outlook_calendar') }}</li>
                <li>{{ $t('apple_calendar') }}</li>
                <li>{{ $t('_integrations.ical.line_05') }}</li>
            </ul>
            <div class="alert alert_default">
                <strong>{{ $t('attention') }}! </strong>{{ $t('_integrations.ical.line_02') }}.
            </div>
            <hr>
            <div v-pml-block="isLoading">
                <div v-if="key">
                    <div class="m-b-15">
                        <label>{{ $t('_integrations.ical.line_03') }}:</label>
                        <div class="input-group">
                            <input class="form-control input_search" :value="`webcal://api.pumpmylead.com/integrations/ical/${key}`" readonly>
                            <span class="input-group-btn" v-clipboard="`webcal://api.pumpmylead.com/integrations/ical/${key}`" @success="handleSuccess()">
                                <button class="btn btn-primary" v-pml-tooltip="$t('copy')"><i class="fa fa-copy"></i></button>
                            </span>
                        </div>
                    </div>
                    <div class="clearfix">
                        <button @click.prevent="askTo('disable')" v-pml-block="isDisabling" class="btn btn-white pull-left">{{ $t('disconnect') }}</button>
                        <button @click.prevent="askTo('refresh')" v-pml-block="isRefreshing" class="btn btn-default pull-right">{{ $t('key_update') }}</button>
                    </div>
                </div>
                <div v-else>
                    <div class="text-right">
                        <button @click.prevent="askTo('enable')" v-pml-block="isEnabling" class="btn btn-default">{{ $t('connect') }}</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel-group" id="accordion">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne-2" aria-expanded="true" class="collapsed">
                            {{ $t('_integrations.ical.line_04') }}
                        </a>
                    </h4>
                </div>
                <div id="collapseOne-2" class="panel-collapse collapse">
                    <div class="p-20">
                        <div class="infographic helper_list t_left">
                            <span class="circle">1</span>
                            <p>{{ $t('open_your') }} <b><a href="https://calendar.google.com" target="_blank">{{ $t('google_calendar') }}</a></b></p>
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">2</span>
                            <p>{{ $t('_integrations.ical.line_06') }} <b>'{{ $t('other_agenda') }}'</b></p>
                            <img src="/static/images/integrations/google-calendar/stage-01.jpg" alt="" class="img-responsive">
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">3</span>
                            <p>{{ $t('select_the_option') }} <b>'{{ $t('add_by_url') }}'</b></p>
                            <img src="/static/images/integrations/google-calendar/stage-02.jpg" alt="" class="img-responsive">
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">4</span>
                            <p>{{ $t('_integrations.ical.line_07') }} <b>'{{ $t('add_agenda') }}'</b></p>
                            <img src="/static/images/integrations/google-calendar/stage-03.jpg" alt="" class="img-responsive">
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">5</span>
                            <p><b>{{ $t('good') }}!</b> {{ $t('_integrations.ical.line_08') }}</p>
                            <img src="/static/images/integrations/google-calendar/stage-04.jpg" alt="" class="img-responsive">
                        </div>
                        <div class="alert alert_default t_center m-0">
                            {{ $t('_integrations.ical.line_09') }} <a href="https://support.google.com/calendar/answer/37118?hl=pt-BR&ref_topic=3417927" target="_blank">{{ $t('google_calendar') }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapseTwo-2" class="collapsed" aria-expanded="true">
                            {{ $t('_integrations.ical.line_10') }}
                        </a>
                    </h4>
                </div>
                <div id="collapseTwo-2" class="panel-collapse collapse">
                    <div class="p-20">
                        <div class="infographic helper_list t_left">
                            <span class="circle">1</span>
                            <p>{{ $t('open_your') }} <b>{{ $t('apple_calendar') }}</b></p>
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">2</span>
                            <p>{{ $t('_integrations.ical.line_11') }} <b>'{{ $t('file') }}'</b> {{ $t('_integrations.ical.line_12') }} <b>'{{ $t('_integrations.ical.line_13') }}...'</b></p>
                            <img src="/static/images/integrations/mac/stage-01.jpg" alt="" class="img-responsive">
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">3</span>
                            <p>{{ $t('_integrations.ical.line_14') }} <b>'{{ $t('sign_up') }}'</b></p>
                            <img src="/static/images/integrations/mac/stage-02.jpg" alt="" class="img-responsive">
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">4</span>
                            <p>{{ $t('_integrations.ical.line_15') }} <b>'{{ $t('ok') }}'</b></p>
                            <img src="/static/images/integrations/mac/stage-03.jpg" alt="" class="img-responsive">
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">5</span>
                            <p><b>{{ $t('good') }}!</b> {{ $t('_integrations.ical.line_16') }}</p>
                        </div>
                        <div class="alert alert_default t_center m-0">
                            {{ $t('_integrations.ical.line_09') }} <a href="https://support.apple.com/kb/PH11524?locale=en_US&viewlocale=pt_PT" target="_blank">{{ $t('apple_calendar') }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapseThree-2" class="collapsed" aria-expanded="true">
                            {{ $t('_integrations.ical.line_17') }}
                        </a>
                    </h4>
                </div>
                <div id="collapseThree-2" class="panel-collapse collapse">
                    <div class="p-20">
                        <div class="infographic helper_list t_left">
                            <span class="circle">1</span>
                            <p>{{ $t('open_your') }} <b>Outlook</b></p>
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">2</span>
                            <p>{{ $t('_integrations.ical.line_18') }} <b>{{ $t('_integrations.ical.line_19') }}</b>, {{ $t('_integrations.ical.line_20') }} <b>'{{ $t('calendar') }}'</b></p>
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">3</span>
                            <p>{{ $t('_integrations.ical.line_21') }} <b>'{{ $t('add_calendar') }}'</b>, {{ $t('_integrations.ical.line_22') }} <b>'{{ $t('add_from_internet') }}'</b></p>
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">4</span>
                            <p>{{ $t('_integrations.ical.line_23') }} <b>'{{ $t('link_to_the_calendar') }}'</b> {{ $t('_integrations.ical.line_24') }} <b>'{{ $t('save') }}'</b></p>
                        </div>
                        <div class="infographic helper_list t_left">
                            <span class="circle">5</span>
                            <b>{{ $t('good') }}!</b> {{ $t('_integrations.ical.line_25') }}
                        </div>
                        <div class="alert alert_default t_center m-0">
                            {{ $t('_integrations.ical.line_09') }} <a href="https://support.office.com/pt-br/article/Importar-ou-assinar-um-calend%C3%A1rio-no-Outlook-com-ou-no-Outlook-na-Web-CFF1429C-5AF6-41EC-A5B4-74F2C278E98C?omkt=pt-BR&ui=pt-BR&rs=pt-BR&ad=BR" target="_blank">{{ $t('_integrations.ical.line_26') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </master-layout>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { irreversible } from 'utils/helpers/sweet-alert'
    import { trans } from 'utils/helpers/translation'
    import { getICal, disableICal, enableICal, refreshICal } from 'services/integrations'

    export default {
        name: 'iCal',
        data () {
            return {
                key: null,
                isDisabling: false,
                isEnabling: false,
                isRefreshing: false,
                isLoading: false
            }
        },
        metaInfo () {
            return {
                title: trans('integrations') + ' | iCal'
            }
        },
        mounted () {
            this.isLoading = true

            getICal()
                .then(response => { this.key = response.data })
                .catch(() => { Notify.error(trans('_notifications.error')) })
                .then(() => { this.isLoading = false })
        },
        methods: {
            handleSuccess () {
                Notify.info(trans('info_added_to_your_clipboard'))
            },
            askTo (method) {
                irreversible()
                    .then((response) => (response.value) ? this[method]() : null)
            },
            disable () {
                this.isDisabling = true

                disableICal()
                    .then(() => { this.key = null })
                    .catch(() => { Notify.error(trans('_notifications.error')) })
                    .then(() => { this.isDisabling = false })
            },
            enable () {
                this.isEnabling = true

                enableICal()
                    .then(response => { this.key = response.data })
                    .catch(() => { Notify.error(trans('_notifications.error')) })
                    .then(() => { this.isEnabling = false })
            },
            refresh () {
                this.isRefreshing = true

                refreshICal()
                    .then(response => { this.key = response.data })
                    .catch(() => { Notify.error(trans('_notifications.error')) })
                    .then(() => { this.isRefreshing = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/providers/iCal.vue